/* RESPONSIBLE TEAM: team-self-serve */

export interface IntershopPlanCardData {
  nameWithProduct: string;
  description: string;
  planSvg?: string;
  features?: Array<string>;
  prefix?: string;
}

export default {};
